import { map, catchError } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, Observable } from 'rxjs';
import { ComponentObject } from '../models/componet.model';
import { EDIT_LIBRARY_OPTIONS } from '../tokens/edit-library-options.token';
import { EditLibraryOptions } from '../models/edit-library-options.model';
import { LogService, IAuthorizationService } from '@pershing/pershing-core';

@Injectable()
export class ComponentListService {

    componentList: ComponentObject[];
    baseUrl: string;
    private componentEntitlements: any;
    entBaseUrl: string = './src/assets/component-entitlements.json';
    private defaultEntitlements: any = {};

    constructor(
        private http: HttpClient,
        private authService: IAuthorizationService,
        private logService: LogService,
        @Optional() @Inject(EDIT_LIBRARY_OPTIONS) private editLibraryOptions: EditLibraryOptions) {
        this.baseUrl = this.configureUrl();
        this.fetchComponentEntitlements().subscribe(data => {
            this.logService.log('Component Entitlements Fetched');
        });
        this.retrieveComponents().subscribe();
    }

    configureUrl() {
        // let dataSourceUrl: string = 'https://component-registry.dev.bnymellon.net/registry'
        let dataSourceUrl: string = null;
        if (this.editLibraryOptions && this.editLibraryOptions.componentRegistryURL) {
            dataSourceUrl = this.editLibraryOptions.componentRegistryURL;
        }
        return dataSourceUrl;
    }

    retrieveComponents(): Observable<ComponentObject[]> {
        if (this.componentList) {   // Only fetch once from service
            return of(cloneDeep(this.componentList));
        } else if (this.baseUrl) {
            return this.http.get(this.baseUrl + '/components').pipe(
                map((data: any) => {
                    this.componentList = data.response;
                    this.componentList = this.checkEntitlements(this.componentList);
                    return cloneDeep(this.componentList);
                })
            );
        } else {
            return of(null);
        }
    }
    generateComponentId(): Observable<string> {
        if (this.baseUrl) {
            return this.http.get(this.baseUrl + '/generateComponentId').pipe(
                map((data: any) => {
                    return data.response;
                })
            );
        } else {
            return of(null);
        }
    }
    fetchComponentByBusinessComponentId(businessComponentId: string): ComponentObject {
        if (this.componentList) {
            return this.componentList.filter(x => (x.businessComponentId === businessComponentId))[0];
        } else {
            return null;
        }
    }
    fetchComponentBySelector(selector: string): any {
        if (this.componentList) {
            return this.componentList.filter(x => (x.componentSelector === selector))[0];
        } else {
            return null;
        }
    }
    checkEntitlements(components: ComponentObject[]): ComponentObject[] {
        let entitledComponents: ComponentObject[] = [];
        for (let component of components) {
            if (this.authService && this.componentEntitlements && this.componentEntitlements[component.componentSelector]) {
                if (this.authService.isEntitled(this.componentEntitlements[component.componentSelector])) {
                    entitledComponents.push(component);
                }
            } else {
                entitledComponents.push(component);
            }
        }
        return entitledComponents;
    }
    fetchComponentEntitlements() {
        if (this.componentEntitlements) {
            return of(this.componentEntitlements);
        } else if (this.editLibraryOptions && this.editLibraryOptions.baseCompEntConfigSource) {
            let baseConfig = this.http.get(this.editLibraryOptions.baseCompEntConfigSource)
            .pipe(
                map(res => res),
                catchError(error => of(this.defaultEntitlements)));
            return baseConfig.pipe(
                map(results => {
                    this.componentEntitlements = results;
                    return this.componentEntitlements;
                }),
                catchError(err => this.handleError(' init  ', err)));
        } else {
            return of(null);
        }
    }
    private handleError(methodId: string, error: any) {
        this.logService.error(' Error in method :: ', methodId, error);
        return Observable.throw(error);
    }

}
